<template>
    <a-checkbox :disabled="disabled" :checked="modelValue" @change="onChange">
        <slot></slot>
    </a-checkbox>
</template>

<script>
export default {
    props: ['disabled', 'modelValue'],
    methods: {
        onChange(event) {
            this.$emit('update:modelValue', event.target.checked);
            this.$emit('updateFlag', event.target.checked);
        },
    },
};
</script>
